

import { CRMActivityEntity } from 'src/types/CRMActivityEntity';
import { ActivityFormState, initialFormState } from 'src/types/activityFormState';
import { Customer } from 'src/types/customer';
import { ShipTo } from 'src/types/orderHeaderDropdowns';

export type FormAction =
  | {
      type: 'SetIsFormOpen';
      payload: boolean;
    }
  | {
      type: 'AddActivityClicked';
    }
  | {
      type: 'editActivityClicked';
      payload: number;
    }
  | {
      type: 'setFormActivity';
      payload: CRMActivityEntity;
    }
  | {
      type: 'cancelWithoutSaving';
      payload: null;
    };

/**
 * A reducer for the activity form state. This is for data that is going into the actual form itself.
 * @param state
 * @param action
 * @returns form state
 */
export const activityFormReducer = (state: ActivityFormState, action: FormAction): ActivityFormState => {
  switch (action.type) {
    case 'SetIsFormOpen':
      return {
        ...state,
        isFormOpen: action.payload,
      };
    case 'AddActivityClicked':
      return {
        ...state,
        isInEditMode: false,
        isFormOpen: true,
      };
    case 'editActivityClicked':
      return {
        ...state,
        isFormOpen: true,
        isInEditMode: true,
        editingActivityId: action.payload,
      };
    case 'setFormActivity':
      return {
        ...state,
        formActivity: action.payload,
      };
    case 'cancelWithoutSaving':
      return {
        ...initialFormState,
      };
    default:
      return state;
  }
};

export function GetDefaultShipToNumber(customer: Customer, res: ShipTo[]): string {
  return customer.selectedShipToNumber && customer.selectedShipToNumber.trim().length > 0
    ? customer.selectedShipToNumber
    : customer.defaultShipTo && customer.defaultShipTo.trim().length > 0
      ? customer.defaultShipTo
      : res[0]?.shipNo && res[0]?.shipNo.trim().length > 0
        ? res[0]?.shipNo
        : '';
}

export function getBuffer(file: File): Promise<string | ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };
  });
}
